import { IPhoneNumberInputProps } from '../models'

export const isPropsEqual = (prev: IPhoneNumberInputProps, next: IPhoneNumberInputProps) =>
  prev.errorMessage === next.errorMessage &&
  prev.isDisabled === next.isDisabled &&
  prev.value === next.value
